// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'

// Internal Dependencies:
import NowPlayingMobileApp from 'components/NowPlaying/NowPlayingMobileApp'

class NowPlayingPage extends React.Component {
	render() {
		const { page } = this.props

		return (
			<div className="mobile-app-page-now-playing">
				<div className="-bg"></div>

				<NowPlayingMobileApp />
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( NowPlayingPage )
